var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"c-pwa-types"},[(_vm.pwaTypes)?_c('div',{staticClass:"c-pwa-types--loaded"},[_c('y-discover-power',{attrs:{"content":_vm.pwaTypes,"custom-btn":_vm.customBtn,"remove-banner":"","show-synopsis":"","button-class":_vm.buttonClass}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }